import {ModalController, NavParams} from '@ionic/angular';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import{ApiService} from '../../../services/api.service';
@Component({
  selector: 'app-detail-nilai',
  templateUrl: './detail-nilai.page.html',
  styleUrls: ['./detail-nilai.page.scss'],
})
export class DetailNilaiPage implements OnInit {

  @ViewChild('barCanvas',{static: false}) barCanvas;


  barChart: any;
  nilai: string = 'semester1';
  dataNilai:any;
  mapel:any;
  mapelNama:any;
  penilaian:any;
  penilaianNama:any;
  kurikulumID:any;
  tahun:any;
  semester:any;
  tingkat:any;
  tingkatNama:any;
  kurikulum:any;


  constructor(private modalCtrl:ModalController, private api:ApiService) { }

  ngOnInit() {    
    this.getBobot();
    this.getTingkatNama();
  }

  getTingkatNama()
  {
      var idx=this.kurikulum.map(function(e){return e.id}).indexOf(this.kurikulumID);
      var idx2=this.kurikulum[idx].penilaian.map(function(e){return e.kode}).indexOf(this.penilaian);
      this.penilaianNama=this.kurikulum[idx].penilaian[idx2].nama;
  }

  getChart()
  {
      setTimeout(() => {
        this.barChart = this.getbarChart();
      }, 150);
  }
  bobot:any={};
  getBobot()
  {
      this.api.data('akademik/bobot?tahun='+this.tahun,'get','').subscribe(data=>{
          this.bobot=data;
          this.getProgram();
      });

  }
  dataProgram:any=[];
  getProgram()
  {
      var params='tahun='+this.tahun+'&semester='+this.semester+'&kategori='+this.penilaian+'&mapelID='+this.mapel+'&tingkat='+this.tingkat;
      this.api.data('akademik/program?'+params,'get','').subscribe(data=>{
          this.parseProgram(data);
      })
  }
  programLabel:any=[];
  programVal:any=[];
  programType:any=[];
  parseProgram(data)
  {
      for(var i=0; i<data.length; i++)
      {
          var nilai=this.dataNilai.data[data[i].kode], bobot, label;
          if(data[i].jenis=='UH') {
            bobot=this.bobot.uh;
            label='Ulangan Harian';
          }
          if(data[i].jenis=='T') 
          {
              bobot=this.bobot.tugas;
              label='Tugas';
          }
          if(data[i].jenis=='UTS') 
          {
              bobot=this.bobot.uts;
              label='UTS';
          }
          if(data[i].jenis=='UAS') 
          {
              bobot=this.bobot.uas;
              label='UAS';
          }
          var dt={
            nilai:nilai,
            program:data[i].nama
          };
          var dt1={
            jenis:data[i].jenis,
            bobot:bobot,
            label:label,
            program:{}
          }
          var cek=this.dataProgram.map(function(e){return e.jenis}).indexOf(data[i].jenis);
          if(cek==-1)
          {
              dt1.program=[dt];
              this.dataProgram.push(dt1);
          }else{
              this.dataProgram[cek].program.push(dt);
          }
          this.programLabel.push(data[i].nama);
          this.programVal.push(nilai);
      }
      console.log(this.dataProgram);
      //this.programType=Object.keys(this.dataProgram);
      this.getChart();
  }

segmentChanged(ev: any) {
    if (ev._value != "semester1 && semester2") {
      setTimeout(() => {
        this.barChart = this.getbarChart();
      }, 150);
    }
}

  getbarChart() {
        this.barChart = new Chart(this.barCanvas.nativeElement, {
            type: 'bar',
            data: {
                labels: this.programLabel,
                datasets: [{
                    data: this.programVal,
                    backgroundColor:'rgba(75, 192, 192, 1)'                    
                }]
            },
            options: {
          legend: {
              display: false
          },
          tooltips: {
              callbacks: {
                 label: function(tooltipItem) {
                        return tooltipItem.yLabel;
                 }
              }
          },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero:true
                        }
                    }]
                }
            }

        });
    }

  closeModal()
  {
    this.modalCtrl.dismiss();
  }

}
